;(function($) {
    window.UpLive = window.UpLive || {};
    var invokeQueue = [];
    var callbacks = [];
    window.__domain = '*';

    $(window)
        .on('message', function(e) {
            /**
             *  e: {Object}
             *  {
             *      cbKey: 1, // 有cbKey，说明执行的是回调函数
             *      result: '11'
             *  }
             */
            var data = e.data;
            try {
                if (typeof data.cbKey == 'number') {
                    callbacks[data.cbKey](data.result);
                } else if (typeof data == 'string' && data.indexOf('http://') > -1) {
                    window.__domain = data;
                }
                if (invokeQueue.length > 0) {
                    invokeQueue.forEach(function(item, index) {
                        window.parent.postMessage(item, window.__domain);
                    });
                    invokeQueue = [];
                }
            } catch (e) {
                console.log(e.message);
            };
        });
    /**
     * @param method {string} 触发操作方法 method
     * @param param {Object} 配置数据
     *          {
     *              a: 1,
     *              b: 2,
     *              success: function(){}
     *              failure: function(){}
     *           }
     */
    function invoke(method, params) {
        var ret = {},
            callbackId,
            p,
            data = {};
        try {
            data = {
                method: method
            };
            if (typeof params == 'object') {
                for (p in params) {
                    if (params.hasOwnProperty(p) && params[p] !== null) {
                        if (typeof params[p] == 'function') {
                            callbackId = callbacks.push(params[p]) - 1;
                            ret[p] = {
                                cbKey: callbackId
                            };
                        } else {
                            ret[p] = params[p];
                        }
                    }
                }
                data.params = ret;
            } else {
                data.params = params;
            }
            if (window.__domain) {
                window.parent.postMessage(data, window.__domain);
            } else {
                invokeQueue.push(data);
            }
        } catch (e) {
            alert(e.message);
        }
    }
    $.extend(UpLive, {
        invoke: invoke
    });
})(Zepto);


// WEBPACK FOOTER //
// ./js/pcuplive.js